import { FC } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { ICompanyCreate } from 'types/Company';

import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { Grid, Tooltip } from '@mui/material';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

import { CompanyDocument } from 'components/CompanyDocument';
import { useParams } from 'react-router-dom';

const MAX_FILES = 4;

interface Props {}

const Input = styled('input')({
  display: 'none',
});

export const CompanyDocumentsForm: FC<Props> = () => {
  const { id: companyId } = useParams<{ id: string }>();
  const { control } = useFormContext<ICompanyCreate>();
  const {
    fields: documents,
    append,
    remove,
  } = useFieldArray({
    control,
    name: 'documents',
  });
  const disableInputs = documents?.length >= MAX_FILES;

  const handleChange = (event: any) => {
    const selectedFile = event.target?.files?.[0] as File;

    if (!selectedFile) {
      return;
    }

    append({ file: selectedFile });
  };

  const handleDelete = (index: number) => () => {
    remove(index);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md="auto">
        <label htmlFor="document">
          <Input
            id="document"
            accept=".pdf,.png,.jpeg,.jpg"
            type="file"
            name="document"
            onChange={handleChange}
            disabled={disableInputs}
          />

          <Tooltip title="Anexar Documento">
            <Button
              variant="outlined"
              component="span"
              size="large"
              fullWidth
              endIcon={<CloudUploadIcon />}
              disabled={disableInputs}
            >
              ANEXAR DOCUMENTO
            </Button>
          </Tooltip>
        </label>
      </Grid>

      <Grid item container spacing={2} xs={12} md={8}>
        {documents?.map((document, index) => (
          <CompanyDocument
            key={document._id ?? document.file?.name}
            document={document}
            onDeleteClick={handleDelete(index)}
            companyId={companyId}
          />
        ))}
      </Grid>
    </Grid>
  );
};
